/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
function getRandomString(len){
    // let min = 0, max = _charStr.length-1, _str = '';
    let min = 0, max = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length-1, _str = '';
    //判断是否指定长度，否则默认长度为15
    len = len || 15;
    //循环生成字符串
    for(var i = 0, index; i < len; i++){
        index = RandomIndex(min, max, i);
        // _str += _charStr[index];
        _str += "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789"[index];
    }
    return _str;
}
/**
 * 生成UUID
 * @returns {string}
 */
function generateShortId(toString = false) {
    let shortId = parseInt(Math.random() * 1e10);
    if (toString) {
        shortId = String(shortId);
    }
    return shortId;
}
/**
 * 随机生成索引
 * @param min 最小值
 * @param max 最大值
 * @param i 当前获取位置
 */
function RandomIndex(min, max, i){
    let index = Math.floor(Math.random()*(max-min+1)+min),

        // numStart = _charStr.length - 10;
        numStart = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length - 10;
    //如果字符串第一位是数字，则递归重新获取
    if(i==0&&index>=numStart){
        index = RandomIndex(min, max, i);
    }
    //返回最终索引值
    return index;
}
/**
 * 判断是否为空
 * @param value
 * @returns {boolean}
 */
function isEmpty(value) {
    if (typeof value === 'undefined') {
        return true;
    } else if (value === null) {
        return true;
    } else if (typeof value === 'string' && value === '') {
        return true;
    } else if (typeof value === 'number' && isNaN(value)) {
        return true;
    } else if (Array.isArray(value) && value.length === 0) {
        return true;
    } else if (value instanceof Number && isNaN(value)) {
        return true;
    } else if (
        value.toString() === '[object Object]' &&
        Object.keys(value).length === 0
    ) {
        return true;
    } else {
        return false;
    }
}
function isNotEmpty(value){
    return !isEmpty(value);
}
/**
 * 获取日期时间信息
 * @param value
 * @returns {object}
 */
function getDateInfo(value) {
    let date, year, month, week, day, hours, minutes, seconds, time;
    if (typeof value === 'string') {
        value = value.replace(/-/g, '/');
    }
    date = !isEmpty(value) ? new Date(value) : new Date();
    year = date.getFullYear();
    month = date.getMonth() + 1;
    month = month > 9 ? month : `0${month}`;
    week = date.getDay();
    day = date.getDate();
    day = day > 9 ? day : `0${day}`;
    hours = date.getHours();
    hours = hours > 9 ? hours : `0${hours}`;
    minutes = date.getMinutes();
    minutes = minutes > 9 ? minutes : `0${minutes}`;
    seconds = date.getSeconds();
    seconds = seconds > 9 ? seconds : `0${seconds}`;
    time = date.getTime();
    return (function () {
        return {
            date: date,
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            week: week,
            day: date.getDate(),
            hours: date.getHours(),
            minutes: date.getMinutes(),
            seconds: date.getSeconds(),
            dateInfo: `${year}-${month}-${day}`,
            timeInfo: `${hours}:${minutes}:${seconds}`,
            dateTimeInfo: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
            time: time,
        };
    })();
}
function getQuery(params){
    let query = '?'
    Object.keys(params).forEach(key=>{
        if(!isEmpty(params[key])){
            if(query == '?'){
                query+=(key+'='+params[key]);
            }else{
                query+=('&'+key+'='+params[key]);
            }
        }
    });
    return query
}
function setTdWidth(cols,tableData){
    cols.forEach(col=>{
        if(col.class == 'my-maximum-wrap-td' && !isEmpty(col.stringMax) && !isEmpty(col.stringMin)){
            let minWidth = 0;
            let oneStrWidth = col?.oneStrWidth ? col?.oneStrWidth : 8;
            let strLenght = _getMaxLenght(col,tableData);
            if(strLenght > col.stringMax){
                minWidth =  col.stringMax * oneStrWidth
            }else if(strLenght < col.stringMin){
                minWidth =  col.stringMin * oneStrWidth
            }else{
                minWidth =  strLenght * oneStrWidth
            }
            col.style = `min-width: ${minWidth}px`;
        }
    })
}
function _getMaxLenght(col,tableData){
    let lenght = 0;
    tableData.forEach(row=>{
        if(!isEmpty(row[col.field]) && lenght < (row[col.field]+'').length){
            lenght = (row[col.field]+'').length
        }
    });
    return lenght;
}
let FUN = {
    /**
     * 添加事件绑定
     * @param element
     * @param event
     * @param handler
     */
    addEvent: (function () {
        if (document.addEventListener) {
            return (element, event, handler, useCapture = false) => {
                element.addEventListener(event, handler, useCapture);
            };
        } else if (document.attachEvent) {
            return (element, event, handler) => {
                element.attachEvent('on' + event, handler);
            };
        } else {
            return (element, event, handler) => {
                element['on' + event] = handler;
            };
        }
    })(),

    /**
     * 移除事件绑定
     * @param element
     * @param event
     * @param handler
     */
    removeEvent: (function () {
        if (document.removeEventListener) {
            return (element, event, handler, useCapture = false) => {
                element.removeEventListener(event, handler, useCapture);
            };
        } else if (document.detachEvent) {
            return (element, event, handler) => {
                element.detachEvent('on' + event, handler);
            };
        } else {
            return (element, event, handler) => {
                element['on' + event] = null;
            };
        }
    })(),
}
const addEvent = FUN.addEvent;
const removeEvent = FUN.removeEvent
export {
    addEvent,
    removeEvent,
    getRandomString,
    generateShortId,
    isEmpty,
    getDateInfo,
    getQuery,
    setTdWidth,
    isNotEmpty
}
